"use client";

import Link from "next/link";

export function AuthLegalNotice() {
  return (
    <p className="text-center text-xs leading-5 text-white/65">
      By continuing, you agree to our{" "}
      <Link
        href="/terms"
        className="font-medium text-white underline decoration-white/40 underline-offset-4 transition hover:text-white"
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        href="/privacy"
        className="font-medium text-white underline decoration-white/40 underline-offset-4 transition hover:text-white"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
}
